import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addContact } from "../../../context/actions/postaction";

const Contact = () => {
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState({ type: "", text: "" });
  const [loading, setLoading] = useState(false);

  const onChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.subject || !form.message) {
      setStatus({ type: "danger", text: "يرجى ملء جميع الحقول المطلوبة." });
      return;
    }

    try {
      setLoading(true);
      setStatus({ type: "", text: "" });
      const response = await dispatch(addContact(form));

      if (response?.status === 200) {
        setStatus({ type: "success", text: "تم إرسال رسالتك بنجاح." });
        setForm({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      } else {
        setStatus({ type: "danger", text: "تعذر إرسال الرسالة." });
      }
    } catch (error) {
      setStatus({ type: "danger", text: "حدث خطأ أثناء إرسال الرسالة." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="content-wrapper">
      <div className="container py-5 mb-2 mb-sm-3 mb-md-4 mb-lg-5 mt-lg-3 mt-xl-4">
        <h1 className="text-center">اتصل بنا</h1>
        <p className="text-center pb-2 pb-sm-3">
          املأ النموذج أدناه وسنرد عليك في غضون 24 ساعة
        </p>

        <section className="row row-cols-1 row-cols-md-2 g-0 overflow-hidden rounded-5">
          <div className="col bg-body-tertiary py-5 px-4 px-xl-5">
            <form className="needs-validation py-md-2 px-md-1 px-lg-3 mx-lg-3" noValidate="" onSubmit={handleSubmit}>
              {status.text ? (
                <div className={`alert alert-${status.type}`}>{status.text}</div>
              ) : null}

              <div className="position-relative mb-4">
                <label htmlFor="name" className="form-label">
                  الاسم *
                </label>
                <input
                  type="text"
                  className="form-control form-control-lg rounded-pill"
                  id="name"
                  value={form.name}
                  onChange={(e) => onChange("name", e.target.value)}
                />
              </div>

              <div className="position-relative mb-4">
                <label htmlFor="email" className="form-label">
                  البريد الإلكتروني *
                </label>
                <input
                  type="email"
                  className="form-control form-control-lg rounded-pill"
                  id="email"
                  value={form.email}
                  onChange={(e) => onChange("email", e.target.value)}
                />
              </div>

              <div className="position-relative mb-4">
                <label htmlFor="phone" className="form-label">
                  رقم الهاتف
                </label>
                <input
                  type="tel"
                  className="form-control form-control-lg rounded-pill"
                  id="phone"
                  value={form.phone}
                  onChange={(e) => onChange("phone", e.target.value)}
                />
              </div>

              <div className="position-relative mb-4">
                <label className="form-label" htmlFor="subject">
                  الموضوع *
                </label>
                <select
                  className="form-select form-select-lg rounded-pill"
                  id="subject"
                  value={form.subject}
                  onChange={(e) => onChange("subject", e.target.value)}
                >
                  <option value="">اختر الموضوع</option>
                  <option value="استفسار عام">استفسار عام</option>
                  <option value="حالة الطلب">حالة الطلب</option>
                  <option value="معلومات المنتج">معلومات المنتج</option>
                  <option value="الدعم الفني">الدعم الفني</option>
                  <option value="ملاحظات الموقع">ملاحظات الموقع</option>
                  <option value="مساعدة الحساب">مساعدة الحساب</option>
                  <option value="أمور أخرى">أمور أخرى</option>
                </select>
              </div>

              <div className="position-relative mb-4">
                <label htmlFor="message" className="form-label">
                  الرسالة *
                </label>
                <textarea
                  className="form-control form-control-lg rounded-6"
                  id="message"
                  rows={5}
                  value={form.message}
                  onChange={(e) => onChange("message", e.target.value)}
                />
              </div>

              <div className="pt-2">
                <button type="submit" className="btn btn-lg btn-dark rounded-pill" disabled={loading}>
                  {loading ? "جارٍ الإرسال..." : "إرسال الرسالة"}
                </button>
              </div>
            </form>
          </div>

          <div className="col position-relative">
            <img
              src="/assets/img/contact/form-image.jpg"
              className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
              alt="صورة"
            />
          </div>
        </section>

        <section className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4 pt-5 pb-3 pb-md-4 pb-lg-3 mt-lg-0 mt-xxl-4">
          <div className="col text-center pt-1 pt-sm-2 pt-md-3">
            <div className="position-relative d-inline-block bg-body-tertiary text-dark-emphasis fs-xl rounded-circle p-4 mb-3">
              <i className="ci-phone-outgoing position-absolute top-50 start-50 translate-middle" />
            </div>
            <h3 className="h6">اتصل بنا مباشرة</h3>
            <ul className="list-unstyled m-0">
              <li className="nav animate-underline justify-content-center">
                العملاء:
                <a className="nav-link animate-target fs-base ms-1 p-0" href="tel:+9647748999948">
                  +964&nbsp;774&nbsp;899&nbsp;9948
                </a>
              </li>
            </ul>
          </div>
          <div className="col text-center pt-1 pt-sm-2 pt-md-3">
            <div className="position-relative d-inline-block bg-body-tertiary text-dark-emphasis fs-xl rounded-circle p-4 mb-3">
              <i className="ci-mail position-absolute top-50 start-50 translate-middle" />
            </div>
            <h3 className="h6">إرسال رسالة</h3>
            <ul className="list-unstyled m-0">
              <li className="nav animate-underline justify-content-center">
                العملاء:
                <a className="nav-link animate-target fs-base ms-1 p-0" href="mailto:info@rusepares.com">
                  info@rusepares.com
                </a>
              </li>
            </ul>
          </div>
          <div className="col text-center pt-1 pt-sm-2 pt-md-3">
            <div className="position-relative d-inline-block bg-body-tertiary text-dark-emphasis fs-xl rounded-circle p-4 mb-3">
              <i className="ci-map-pin position-absolute top-50 start-50 translate-middle" />
            </div>
            <h3 className="h6">موقع المتجر</h3>
            <ul className="list-unstyled m-0">
              <li>تكريت، العراق</li>
              <li>شارع زيونة, صلاح الدين</li>
            </ul>
          </div>
          <div className="col text-center pt-1 pt-sm-2 pt-md-3">
            <div className="position-relative d-inline-block bg-body-tertiary text-dark-emphasis fs-xl rounded-circle p-4 mb-3">
              <i className="ci-clock position-absolute top-50 start-50 translate-middle" />
            </div>
            <h3 className="h6">ساعات العمل</h3>
            <ul className="list-unstyled m-0">
              <li>جميع أيام الأسبوع 10:00 - 23:00</li>
              <li>الجمعة - مغلق</li>
            </ul>
          </div>
        </section>

        <hr className="my-lg-5" />
      </div>
    </main>
  );
};

export default Contact;